// Liste des pays acceptés par Cofidis (Annex — codes ISO 3166-1 alpha-2)
export const COUNTRIES = [
  { code: 'FR', label: 'France' },
  { code: 'AD', label: 'Andorre' },
  { code: 'AE', label: 'Émirats Arabes Unis' },
  { code: 'AF', label: 'Afghanistan' },
  { code: 'AG', label: 'Antigua-et-Barbuda' },
  { code: 'AL', label: 'Albanie' },
  { code: 'AM', label: 'Arménie' },
  { code: 'AO', label: 'Angola' },
  { code: 'AR', label: 'Argentine' },
  { code: 'AT', label: 'Autriche' },
  { code: 'AU', label: 'Australie' },
  { code: 'AZ', label: 'Azerbaïdjan' },
  { code: 'BA', label: 'Bosnie-Herzégovine' },
  { code: 'BB', label: 'Barbade' },
  { code: 'BD', label: 'Bangladesh' },
  { code: 'BE', label: 'Belgique' },
  { code: 'BF', label: 'Burkina Faso' },
  { code: 'BG', label: 'Bulgarie' },
  { code: 'BH', label: 'Bahreïn' },
  { code: 'BI', label: 'Burundi' },
  { code: 'BJ', label: 'Bénin' },
  { code: 'BN', label: 'Brunei' },
  { code: 'BO', label: 'Bolivie' },
  { code: 'BQ', label: 'Bonaire, Saint-Eustache et Saba' },
  { code: 'BR', label: 'Brésil' },
  { code: 'BS', label: 'Bahamas' },
  { code: 'BT', label: 'Bhoutan' },
  { code: 'BW', label: 'Botswana' },
  { code: 'BY', label: 'Biélorussie' },
  { code: 'BZ', label: 'Belize' },
  { code: 'CA', label: 'Canada' },
  { code: 'CD', label: 'Congo (RDC)' },
  { code: 'CF', label: 'République centrafricaine' },
  { code: 'CG', label: 'Congo' },
  { code: 'CH', label: 'Suisse' },
  { code: 'CI', label: 'Côte d\'Ivoire' },
  { code: 'CL', label: 'Chili' },
  { code: 'CM', label: 'Cameroun' },
  { code: 'CN', label: 'Chine' },
  { code: 'CO', label: 'Colombie' },
  { code: 'CR', label: 'Costa Rica' },
  { code: 'CU', label: 'Cuba' },
  { code: 'CV', label: 'Cap-Vert' },
  { code: 'CW', label: 'Curaçao' },
  { code: 'CY', label: 'Chypre' },
  { code: 'CZ', label: 'Tchéquie' },
  { code: 'DE', label: 'Allemagne' },
  { code: 'DJ', label: 'Djibouti' },
  { code: 'DK', label: 'Danemark' },
  { code: 'DM', label: 'Dominique' },
  { code: 'DO', label: 'République dominicaine' },
  { code: 'DZ', label: 'Algérie' },
  { code: 'EC', label: 'Équateur' },
  { code: 'EE', label: 'Estonie' },
  { code: 'EG', label: 'Égypte' },
  { code: 'ER', label: 'Érythrée' },
  { code: 'ES', label: 'Espagne' },
  { code: 'ET', label: 'Éthiopie' },
  { code: 'FI', label: 'Finlande' },
  { code: 'FJ', label: 'Fidji' },
  { code: 'FM', label: 'Micronésie' },
  { code: 'GA', label: 'Gabon' },
  { code: 'GB', label: 'Royaume-Uni' },
  { code: 'GD', label: 'Grenade' },
  { code: 'GE', label: 'Géorgie' },
  { code: 'GH', label: 'Ghana' },
  { code: 'GM', label: 'Gambie' },
  { code: 'GN', label: 'Guinée' },
  { code: 'GQ', label: 'Guinée équatoriale' },
  { code: 'GR', label: 'Grèce' },
  { code: 'GT', label: 'Guatemala' },
  { code: 'GW', label: 'Guinée-Bissau' },
  { code: 'GY', label: 'Guyana' },
  { code: 'HK', label: 'Hong Kong' },
  { code: 'HN', label: 'Honduras' },
  { code: 'HR', label: 'Croatie' },
  { code: 'HT', label: 'Haïti' },
  { code: 'HU', label: 'Hongrie' },
  { code: 'ID', label: 'Indonésie' },
  { code: 'IE', label: 'Irlande' },
  { code: 'IL', label: 'Israël' },
  { code: 'IN', label: 'Inde' },
  { code: 'IQ', label: 'Irak' },
  { code: 'IR', label: 'Iran' },
  { code: 'IS', label: 'Islande' },
  { code: 'IT', label: 'Italie' },
  { code: 'JM', label: 'Jamaïque' },
  { code: 'JO', label: 'Jordanie' },
  { code: 'JP', label: 'Japon' },
  { code: 'KE', label: 'Kenya' },
  { code: 'KG', label: 'Kirghizistan' },
  { code: 'KH', label: 'Cambodge' },
  { code: 'KI', label: 'Kiribati' },
  { code: 'KM', label: 'Comores' },
  { code: 'KN', label: 'Saint-Christophe-et-Niévès' },
  { code: 'KP', label: 'Corée du Nord' },
  { code: 'KR', label: 'Corée du Sud' },
  { code: 'KW', label: 'Koweït' },
  { code: 'KZ', label: 'Kazakhstan' },
  { code: 'LA', label: 'Laos' },
  { code: 'LB', label: 'Liban' },
  { code: 'LC', label: 'Sainte-Lucie' },
  { code: 'LI', label: 'Liechtenstein' },
  { code: 'LK', label: 'Sri Lanka' },
  { code: 'LR', label: 'Libéria' },
  { code: 'LS', label: 'Lesotho' },
  { code: 'LT', label: 'Lituanie' },
  { code: 'LU', label: 'Luxembourg' },
  { code: 'LV', label: 'Lettonie' },
  { code: 'LY', label: 'Libye' },
  { code: 'MA', label: 'Maroc' },
  { code: 'MC', label: 'Monaco' },
  { code: 'MD', label: 'Moldavie' },
  { code: 'ME', label: 'Monténégro' },
  { code: 'MG', label: 'Madagascar' },
  { code: 'MH', label: 'Îles Marshall' },
  { code: 'MK', label: 'Macédoine du Nord' },
  { code: 'ML', label: 'Mali' },
  { code: 'MM', label: 'Myanmar' },
  { code: 'MN', label: 'Mongolie' },
  { code: 'MR', label: 'Mauritanie' },
  { code: 'MT', label: 'Malte' },
  { code: 'MU', label: 'Maurice' },
  { code: 'MV', label: 'Maldives' },
  { code: 'MW', label: 'Malawi' },
  { code: 'MX', label: 'Mexique' },
  { code: 'MY', label: 'Malaisie' },
  { code: 'MZ', label: 'Mozambique' },
  { code: 'NA', label: 'Namibie' },
  { code: 'NE', label: 'Niger' },
  { code: 'NG', label: 'Nigéria' },
  { code: 'NI', label: 'Nicaragua' },
  { code: 'NL', label: 'Pays-Bas' },
  { code: 'NO', label: 'Norvège' },
  { code: 'NP', label: 'Népal' },
  { code: 'NR', label: 'Nauru' },
  { code: 'NZ', label: 'Nouvelle-Zélande' },
  { code: 'OM', label: 'Oman' },
  { code: 'PA', label: 'Panama' },
  { code: 'PE', label: 'Pérou' },
  { code: 'PG', label: 'Papouasie-Nouvelle-Guinée' },
  { code: 'PH', label: 'Philippines' },
  { code: 'PK', label: 'Pakistan' },
  { code: 'PL', label: 'Pologne' },
  { code: 'PS', label: 'Palestine' },
  { code: 'PT', label: 'Portugal' },
  { code: 'PW', label: 'Palaos' },
  { code: 'PY', label: 'Paraguay' },
  { code: 'QA', label: 'Qatar' },
  { code: 'RO', label: 'Roumanie' },
  { code: 'RS', label: 'Serbie' },
  { code: 'RU', label: 'Russie' },
  { code: 'RW', label: 'Rwanda' },
  { code: 'SA', label: 'Arabie Saoudite' },
  { code: 'SB', label: 'Îles Salomon' },
  { code: 'SC', label: 'Seychelles' },
  { code: 'SD', label: 'Soudan' },
  { code: 'SE', label: 'Suède' },
  { code: 'SG', label: 'Singapour' },
  { code: 'SI', label: 'Slovénie' },
  { code: 'SK', label: 'Slovaquie' },
  { code: 'SL', label: 'Sierra Leone' },
  { code: 'SM', label: 'Saint-Marin' },
  { code: 'SN', label: 'Sénégal' },
  { code: 'SO', label: 'Somalie' },
  { code: 'SR', label: 'Suriname' },
  { code: 'SS', label: 'Soudan du Sud' },
  { code: 'ST', label: 'Sao Tomé-et-Principe' },
  { code: 'SV', label: 'Salvador' },
  { code: 'SX', label: 'Saint-Martin (partie néerlandaise)' },
  { code: 'SZ', label: 'Eswatini' },
  { code: 'TD', label: 'Tchad' },
  { code: 'TG', label: 'Togo' },
  { code: 'TH', label: 'Thaïlande' },
  { code: 'TJ', label: 'Tadjikistan' },
  { code: 'TL', label: 'Timor oriental' },
  { code: 'TM', label: 'Turkménistan' },
  { code: 'TN', label: 'Tunisie' },
  { code: 'TO', label: 'Tonga' },
  { code: 'TR', label: 'Turquie' },
  { code: 'TT', label: 'Trinité-et-Tobago' },
  { code: 'TV', label: 'Tuvalu' },
  { code: 'TW', label: 'Taïwan' },
  { code: 'TZ', label: 'Tanzanie' },
  { code: 'UA', label: 'Ukraine' },
  { code: 'UG', label: 'Ouganda' },
  { code: 'US', label: 'États-Unis' },
  { code: 'UY', label: 'Uruguay' },
  { code: 'UZ', label: 'Ouzbékistan' },
  { code: 'VA', label: 'Saint-Siège (Vatican)' },
  { code: 'VC', label: 'Saint-Vincent-et-les-Grenadines' },
  { code: 'VE', label: 'Venezuela' },
  { code: 'VN', label: 'Viêt Nam' },
  { code: 'VU', label: 'Vanuatu' },
  { code: 'WS', label: 'Samoa' },
  { code: 'XK', label: 'Kosovo' },
  { code: 'YE', label: 'Yémen' },
  { code: 'ZA', label: 'Afrique du Sud' },
  { code: 'ZM', label: 'Zambie' },
  { code: 'ZW', label: 'Zimbabwe' },
];

// Helper pour obtenir le label d'un pays par son code
export function getCountryLabel(code: string): string {
  const country = COUNTRIES.find(c => c.code === code);
  return country ? country.label : code;
}

// Helper pour formater les pays pour SelectField
export function getCountryOptions() {
  return COUNTRIES.map(country => ({
    value: country.code,
    label: country.label
  }));
}
